export enum FEEDBACK_TYPE {
  QUESTION = 'Question',
  FEEDBACK = 'Feedback',
  FEATURE_REQUEST = 'Feature request',
}
